import React from "react";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import { lightScrollbarStyle } from "../../../../styles/lightScrollbarStyle";

interface CompetitorTooltipProps {
  products: string[];
}

export const CompetitorPresenceTooltip: React.FC<CompetitorTooltipProps> = ({
  products,
}) => {
  if (products.length === 0) return null;

  const needsScroll = products.length > 10; // Show scroll after 10 items

  return (
    <Box
      sx={{
        maxHeight: needsScroll ? 300 : "auto", // Limit height when many items
        overflowY: needsScroll ? "auto" : "visible",
        pr: needsScroll ? 1 : 0, // Add padding for scrollbar
        ...lightScrollbarStyle,
      }}
    >
      {products.map((product, index) => (
        <Typography
          key={`product-${index}`}
          variant="body2"
          className="product-item"
          sx={{
            fontSize: "12px",
            fontWeight: "normal",
            color: "rgba(0, 0, 0, 0.7)",
            py: 0.25, // Small vertical padding for better readability
          }}
        >
          {product}
        </Typography>
      ))}
    </Box>
  );
};
